<div class="entity-selector">
  <form [formGroup]="inputFormGroup">
    <input class="entity-selector__search-input"
           [matAutocomplete]="auto"
           [matAutocompletePosition]="isMobile ? 'above' : 'below'"
           formControlName="naam"
           [placeholder]="placeholder"
    />
    <mat-autocomplete (optionSelected)="select($event)"
                      #auto="matAutocomplete">
      <mat-option *ngFor="let option of filteredOptions" [value]="option">
        {{ option.naam }}
      </mat-option>
    </mat-autocomplete>
  </form>
</div>
